let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aqVlS")).then(() => parcelRequire('efnA2'));